import { rem } from 'polished'
import styled from 'styled-components'
import theme from 'styles/theme'
import { Eyebrow as ThemeEyebrow, Title60 } from 'components/Typography'

export const Wrapper = styled.section`
  color: ${theme.colors.sagemedium};
  margin: 0;
  padding: 0 20px;
  text-align: center;
`

export const Inner = styled.div`
  margin: 0 auto;
  max-width: 1180px;
`

export const Heading = styled.div`
  margin: 0 38px 40px;

  ${theme.mediaQueries.medium} {
    margin: 0 auto 50px;
    max-width: 780px;
  }
`

export const Eyebrow = styled(ThemeEyebrow)`
  color: ${theme.colors.sagedark};
  margin-bottom: 10px;
`

export const Headline = styled(Title60)`
  margin: 0;
`

export const Body = styled.div`
  margin-top: 20px;
  text-align: center;

  p,
  ul,
  ol {
    font-size: ${rem(14)};

    ${theme.mediaQueries.medium} {
      font-size: ${rem(16)};
    }
  }
`

export const Grid = styled.div`
  ${theme.mediaQueries.small} {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -10px;
  }
`

export const Promo = styled.article`
  margin-top: 60px;

  ${theme.mediaQueries.small} {
    flex: 0 1 50%;
    margin-top: 20px;
    max-width: 50%;
    padding: 0 10px;
  }

  ${theme.mediaQueries.medium} {
    flex-basis: 33.33334%;
    max-width: 33.33334%;
  }

  &:first-child {
    margin-top: 0;
  }

  &:nth-child(-n + 2) {
    ${theme.mediaQueries.small} {
      margin-top: 0;
    }
  }

  &:nth-child(-n + 3) {
    ${theme.mediaQueries.medium} {
      margin-top: 0;
    }
  }
`
